<template>
  <div class="main">
    <vue-headful title="阀门专用工具查询" description="阀门专用工具查询" />
    <div class="header">
      <div class="left"></div>
      <div class="right"></div>
    </div>
    <div class="container">
      <div class="logo">
        <img src="../assets/spxflow-logo-2C.png" alt="SPX logos" />
      </div>
      <p class="desc">请在下方下拉菜单中依次选择"产品类型”、“产品型号”及“产品尺寸”后，点击“提交”，即可查询维护保养该产品所需使用的专用工具。</p>
      <div class="selects">
        <select name="type" id="id_type" v-model="type" :class="{ active: type != 0 }">
          <option selected value="0">产品类型</option>
          <option :key="t.id" :value="t.id" v-for="t in types">
            {{ t.name }}
          </option>
        </select>
        <select name="model" id="id_model" v-model="model" :class="{ active: model != 0 }">
          <option value="0" selected>产品型号</option>
          <option :key="m.id" :value="m.id" v-for="m in models">
            {{ m.name }}
          </option>
        </select>
        <select name="size" id="id_size" v-model="size" :class="{ active: size != 0 }">
          <option value="0" selected>产品尺寸</option>
          <option :key="s.id" :value="s.id" v-for="s in sizes">
            {{ s.name }}
          </option>
        </select>
        <!-- <select name="material" id="id_material" v-model="material">
          <option value="0" selected>备件材质</option>
          <option :key="ma.id" :value="ma.id" v-for="ma in materials">{{ma.name}}</option>
        </select>-->
        <div>
          <button class="submit" @click="search()" :disabled="type == 0 || model == 0 || size == 0">提交</button>
        </div>
      </div>
      <div class="results" v-if="parts.length > 0 || tools.length > 0">
        <p>所需专用工具</p>

        <div class="result" :key="result.id" v-for="(result, idx) in tools">
          <p class="title">专用工具{{ idx + 1 }}: {{ result.sn }}</p>
          <p class="desc">{{ result.name }}</p>
          <p class="desc">{{ result.desc }}</p>
          <img :src="result.img" alt v-if="result.img" />
        </div>

        <p v-if="parts.length > 0">备件包</p>

        <div class="result" :key="result.id" v-for="(result, idx) in parts">
          <p class="title">备件包{{ idx + 1 }}: {{ result.sn }}</p>
          <p class="desc">{{ result.name }}</p>
          <p class="desc">{{ result.desc }}</p>
          <img :src="result.img" alt v-if="result.img" />
        </div>
      </div>
      <div v-else>
        <br />
        <br />
      </div>
    </div>
    <div class="footer">
      <img src="@/assets/footer.png" alt="" />
      <!-- <div class="top"></div>
      <div class="content">
        <div class="qr">
          <img src="@/assets/qr.jpeg" alt="" />
        </div>
        <div class="info">
          <h5>长按左侧二维码关注,了解更多</h5>
          <p>斯必克流体中国</p>
          <p>网址：spxflow.com/cn</p>
          <p>电话：86-21-2208 5888</p>
          <p>售后服务电话：4001-528-008</p>
          <p>邮箱：china.contact@spxflow.com</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import {
  partSearch,
  getProductSizes,
  getProductTypes,
  getProductModels,
  // getPartMaterials,
} from "@/api/request";

export default {
  name: "valve",
  data() {
    return {
      types: [],
      models: [],
      sizes: [],
      materials: [],
      type: 0,
      model: 0,
      size: 0,
      material: 0,
      tools: [],
      parts: [],
    };
  },
  methods: {
    authenticate() {
      // let url = encodeURIComponent(location.href)
      // let appId = 'wxa835709a6a52c7bc'
      // let state = 'stateless'
      // location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`
    },
    async search() {
      let loader = this.$loading.show({
        canCancel: true,
      });
      try {
        let data = await partSearch({
          type: this.type,
          model: this.model,
          size: this.size,
          // material: this.material,
        });
        this.tools = data.tools;
        this.parts = data.parts;
        loader.hide();
      } catch (error) {
        Toast(error);
        loader.hide();
      }
    },
  },
  watch: {
    async type() {
      let loader = this.$loading.show({
        canCancel: true,
      });
      try {
        let data = await getProductModels({
          product_type_id: this.type,
        });
        this.models = data;
        this.model = 0;
        this.size = 0;
        loader.hide();
      } catch (error) {
        Toast(error);
        loader.hide();
      }
    },
    async model() {
      let loader = this.$loading.show({
        canCancel: true,
      });
      try {
        let data = await getProductSizes({
          product_type_id: this.type,
          product_model_id: this.model,
        });
        this.sizes = data;
        this.size = 0;
        loader.hide();
      } catch (error) {
        Toast(error);
        loader.hide();
      }
    },
  },
  async mounted() {
    let loader = this.$loading.show({
      canCancel: true,
    });
    try {
      let data = await getProductTypes();
      this.types = data;
      let data_models = await getProductModels();
      this.models = data_models;
      let data_sizes = await getProductSizes();
      this.sizes = data_sizes;
      // let materials = await getPartMaterials();
      // this.materials = materials;
      loader.hide();
    } catch (error) {
      Toast(error);
      loader.hide();
    }

    this.authenticate();
  },
};
</script>

<style lang="scss" scoped>
.container {
  text-align: center;
  padding-top: 20px;
  box-sizing: border-box;
  min-height: calc(100vh - 238px);
  .logo {
    img {
      margin: 20px auto;
      width: 250px;
    }
  }
  .name {
    font-weight: 700;
    font-size: 18px;
    color: rgba(101, 99, 99, 1);
  }
  .desc {
    color: #656464;
    margin: 0px 24px 24px 24px;
    text-align: left;
    line-height: 32px;
  }
  .selects {
    padding: 0 24px;
    select {
      width: 100%;
      height: 46px;
      border: 1px solid #1d4f48;
      opacity: 0.7;
      background: #fff;
      border-radius: 20px 0px 20px 0px;
      margin-bottom: 17px;
      font-size: 17px;
      font-weight: normal;
      color: rgba(126, 124, 124, 1);
      line-height: 21px;
      padding-left: 10px;
    }
  }
}
.submit {
  margin-top: 12px;
  background: #1d4f48;
  color: #fff;
  border-radius: 21px;
  border: none;
  width: 129px;
  height: 43px;
  font-size: 17px;
  line-height: 43px;
  outline: none;
  &:active {
    background-color: #1d4f48;
    box-shadow: 0 1px #666;
    transform: translateY(1px);
  }

  &:active {
    outline: none;
  }
  &:disabled {
    background-color: #d7d7d7;
  }
}
.results {
  background-color: #f3f3f3;
  padding: 18px;
  margin: 30px 24px;
  border-radius: 5px;

  > p {
    color: #1d4f48;
    line-height: 32px;
    margin: 0;
    margin-bottom: 10px;
    font-weight: 600;
  }

  .result {
    text-align: left;
    background-color: #fff;
    padding: 16px;
    margin-bottom: 20px;
    .title {
      margin: 0px;
      margin-bottom: 10px;
    }
    .desc {
      margin: 0;
      font-size: 14px;
      font-weight: 400;
      color: rgba(101, 100, 100, 1);
      line-height: 23px;
    }
    img {
      margin-top: 10px;
      width: 100%;
    }
  }
}
select.active {
  color: #333 !important;
}

.float {
  position: fixed;
  bottom: 20%;
  right: 0;
  img {
    width: 51px;
  }
}
</style>
